import React, { useMemo, useState } from 'react';
import DashboardPieChart from './charts/DashboardPieChart';
import { EMAIL_STATS_WINDOWS, SMS_STATS_CATEGORIES } from '../dashboardStatsConfig';
import { parseStatValue } from '../dashboardStatUtils';
import { VIBRANT_PALETTE } from '../dashboardChartColors';

function DashboardSmsStats({ getStat, isLoading, loadError, lastUpdated }) {
    const [days, setDays] = useState(30);

    const series = useMemo(
        () =>
            SMS_STATS_CATEGORIES.map((category, index) => ({
                key: category.keyPrefix,
                label: category.label,
                color: VIBRANT_PALETTE[index % VIBRANT_PALETTE.length],
                value: parseStatValue(getStat(`${category.keyPrefix}_${days}_DAYS`)),
            })),
        [days, getStat]
    );

    const hasData = series.some((item) => item.value > 0);
    const total = series.reduce((sum, item) => sum + item.value, 0);

    return (
        <section className="ecx-page-card ecx-page-panel dashboard-stats-panel">
            <div className="ecx-page-panel__header">
                <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                    <div className="dashboard-stats-panel__heading">
                        <span className="ecx-page-icon-badge">
                            <i className="bi bi-chat-dots" />
                        </span>
                        <div>
                            <h2 className="dashboard-stats-panel__title">SMS Stats</h2>
                            <p className="dashboard-stats-panel__subtitle mb-0">
                                {lastUpdated
                                    ? `Sent SMS by category · Updated ${lastUpdated}`
                                    : 'Sent SMS distributed by reminder category'}
                            </p>
                        </div>
                    </div>
                    <div className="dashboard-email-stats__toggle" role="group" aria-label="SMS stats period">
                        {EMAIL_STATS_WINDOWS.map((window) => (
                            <button
                                key={window.days}
                                type="button"
                                className={`dashboard-email-stats__toggle-btn${days === window.days ? ' is-active' : ''}`}
                                onClick={() => setDays(window.days)}
                            >
                                {window.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            <div className="ecx-page-panel__body">
                {loadError && (
                    <div className="dashboard-alert" role="alert">
                        <i className="bi bi-exclamation-circle me-2" />
                        {loadError}
                    </div>
                )}

                {isLoading ? (
                    <div className="dashboard-stat-tile dashboard-stat-tile--skeleton" style={{ minHeight: 280 }} />
                ) : !hasData ? (
                    <div className="dashboard-empty-state">
                        <i className="bi bi-pie-chart me-2" />
                        No sent SMS in the last {days} days
                    </div>
                ) : (
                    <>
                        <p className="dashboard-email-stats__total mb-3">
                            Total sent: <strong>{total.toLocaleString()}</strong>
                        </p>
                        <DashboardPieChart series={series} />
                    </>
                )}
            </div>
        </section>
    );
}

export default DashboardSmsStats;
